<nz-row class="em-area">
  <nz-col nzSpan="24">
    <em-maintenance-management-system-details></em-maintenance-management-system-details>
  </nz-col>
</nz-row>

<nz-row class="em-area">
  <nz-col nzSpan="24">
    <em-mould-card-details
      *emVisibleForRoles="['Mould Engineering', 'Front End']"
    ></em-mould-card-details>
  </nz-col>
</nz-row>
<nz-row class="em-area">
  <nz-col nzSpan="24">
    <em-construction-details
      *emVisibleForRoles="['Mould Engineering', 'Front End']"
    ></em-construction-details>
  </nz-col>
</nz-row>
<nz-row class="em-area">
  <nz-col nzSpan="24">
    <em-equipment-details
      *emVisibleForRoles="['Novelty', 'Mould Engineering', 'Front End']"
    ></em-equipment-details>
  </nz-col>
</nz-row>
<nz-row class="em-area">
  <nz-col nzSpan="24">
    <em-visitation *emVisibleForRoles="['Mould Engineering']"></em-visitation>
  </nz-col>
</nz-row>
<nz-row class="em-area">
  <nz-col nzSpan="24">
    <em-mould-decision-tool *emVisibleForRoles="['Mould Engineering']"></em-mould-decision-tool>
  </nz-col>
</nz-row>
